function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcasePortfolioSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 501.551 501.551",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M332.278,0H166.139c-19.853,0-36.571,16.718-36.571,36.571v102.4h239.282v-102.4 C368.849,16.718,352.131,0,332.278,0z M337.502,107.624H160.914V36.571c0-3.135,2.09-5.224,5.224-5.224h166.139 c3.135,0,5.224,2.09,5.224,5.224V107.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334A5E"
    },
    d: "M12.539,318.694v161.959c0,11.494,9.404,20.898,20.898,20.898h434.678 c11.494,0,20.898-9.404,20.898-20.898V318.694H12.539z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9CAAB5"
    },
    points: "368.849,73.143 368.849,138.971 129.567,138.971 129.567,73.143 160.914,73.143  160.914,107.624 337.502,107.624 337.502,73.143 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M480.653,88.816H20.898C9.404,88.816,0,98.22,0,109.714v198.531c0,11.494,9.404,20.898,20.898,20.898 h459.755c11.494,0,20.898-9.404,20.898-20.898V109.714C501.551,98.22,492.147,88.816,480.653,88.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD6E0"
    },
    d: "M250.776,361.535L250.776,361.535c-15.673,0-28.212-12.539-28.212-28.212v-4.18h56.424v4.18 C278.988,348.996,266.449,361.535,250.776,361.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M260.18,296.751h-17.763c-15.673,0-28.212,12.539-28.212,28.212v4.18h74.188v-4.18 C288.392,309.29,275.853,296.751,260.18,296.751z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcasePortfolioSvgrepoCom);
export default __webpack_public_path__ + "static/media/suitcase-portfolio-svgrepo-com.2a13885a0b4633b41353b0710f17f058.svg";
export { ForwardRef as ReactComponent };